import { createContext } from "preact";
import { IActionButton, IData, ILink } from "./type";

export const NavbarContext = createContext<{
  links: ILink[];
  siteId: string;
  buttons: IActionButton[];
  logoData: IData;
  refetch: (silent?: boolean) => void;
  save: (value: any) => Promise<any>;
  update: (value: any) => any;
  saveLink: (link: ILink) => Promise<any>;
  saveButton: (button: IActionButton) => Promise<any>;
}>({
  links: [],
  siteId: "",
  save: async (value) => null,
  refetch: (value) => null,
  update: (value) => null,
  saveLink: (value) => null,
  saveButton: (value) => null,
  buttons: [],
  logoData: {
    id: "",
    logo_type: "text",
    logo_image: "",
    logo_text: "",
    logo_emoji: "",
    logo_size: 0,
    height: 0,
    is_floating: false,
    background_color: "",
    color: "",
  },
});
